<p-card class="h-full" styleClass="h-full">
	<ng-template pTemplate="header">
		<div class="flex flex-col flex-auto space-y-3 px-12 pt-6">
			<span class="text-lg font-medium">
				{{ controller.cardHeader$ | async }}
			</span>
			<div
				*ngLet="controller.userNetworkMicrosoftState$ | async as networkState"
				class="flex space-x-1"
			>
				<div
					[class.bg-amber-500]="controller.isExpired$ | async"
					[class.bg-green-600]="controller.isActive$ | async"
					[class.bg-neutral-400]="controller.isNotActive$ | async"
					class="p-rounded h-4 w-4"
				></div>
				<span class="text-base leading-none">
					{{ controller.i18n + '.networkState.' + networkState | translate }}
				</span>
			</div>
		</div>
	</ng-template>

	<div class="flex flex-col space-y-6">
		<div *ngIf="controller.isActive$ | async" class="flex flex-col space-y-3">
			<label>{{ controller.i18n + '.calendar.label' | translate }}</label>
			<div class="grid grid-cols-8 gap-6">
				<p-multiSelect
					[defaultLabel]="controller.i18n + '.calendar.placeholder' | translate"
					[disabled]="controller.isExpired$ | async"
					[ngModel]="controller.selectedCalendarsId$ | async"
					[options]="controller.userMicrosoftExternalCalendars$ | async"
					[style]="{ width: '100%' }"
					(ngModelChange)="onCalendarsIdChange($event)"
					class="col-span-4"
					appendTo="body"
				></p-multiSelect>
				<p-progressSpinner
					*ngIf="controller.isSynchronizing$ | async; else synchronize"
					[style]="{ width: '30px', height: '30px' }"
					class="justify-self-end"
				></p-progressSpinner>
				<ng-template #synchronize>
					<button
						[disabled]="controller.canNotSynchronize$ | async"
						[label]="controller.synchronizeButtonLabel$ | async"
						(click)="onSynchronizeSelectedCalendarClick($event)"
						class="p-button-outlined justify-self-end col-start-8"
						pButton
						type="button"
					></button>
				</ng-template>
			</div>
		</div>
		<span *ngIf="controller.isExpired$ | async" class="font-semibold">
			{{ controller.i18n + '.expiredMessage' | translate }}
		</span>
		<div
			[class.justify-between]="controller.isExpired$ | async"
			class="flex justify-center items-stretch space-x-3"
		>
			<p-progressSpinner
				*ngIf="controller.isLoading$ | async; else loaded"
				[style]="{ width: '30px', height: '30px' }"
			></p-progressSpinner>
			<ng-template #loaded>
				<button
					*ngIf="controller.isNotActive$ | async"
					[label]="controller.i18n + '.connect.label' | translate"
					(click)="onConnectClick()"
					class="p-button-outlined grow"
					pButton
					type="button"
				></button>
				<button
					*ngIf="controller.canDisconnect$ | async"
					[class.grow]="controller.isActive$ | async"
					[disabled]="controller.isReconnecting$ | async"
					[label]="controller.i18n + '.disconnect.label' | translate"
					(click)="onDisconnectClick()"
					class="p-button-grey"
					pButton
					type="button"
				></button>
			</ng-template>
			<p-progressSpinner
				*ngIf="controller.isReconnecting$ | async; else reconnected"
				[style]="{ width: '30px', height: '30px' }"
				class="justify-self-end"
			></p-progressSpinner>
			<ng-template #reconnected>
				<button
					*ngIf="controller.isExpired$ | async"
					[label]="controller.i18n + '.reconnect.label' | translate"
					(click)="onReconnectClick()"
					class="p-button-outlined self-end"
					pButton
					type="button"
				></button>
			</ng-template>
		</div>
	</div>
	<p-confirmPopup></p-confirmPopup>
	<p-toast></p-toast>
</p-card>
